import { createMutationHook, createQueryHook } from "../factory";

const auditRuleKeys = {
  all: ["auditRules"] as const,
  lists: () => [...auditRuleKeys.all, "list"] as const,
  list: () => [...auditRuleKeys.lists()] as const,
  details: () => [...auditRuleKeys.all, "detail"] as const,
  detail: ({ id }: { id: string }) => [...auditRuleKeys.details(), id] as const,
  testResults: () => [...auditRuleKeys.all, "testResults"] as const,
  testResult: ({
    ruleId,
    first,
    after,
  }: {
    ruleId: string;
    first?: number;
    after?: string;
  }) => [...auditRuleKeys.testResults(), ruleId, first, after] as const,
  testResultsCsv: ({ id }: { id: string }) =>
    [...auditRuleKeys.all, "testResultsCsv", id] as const,
  testResultsSummary: ({ ruleId }: { ruleId: string }) =>
    [...auditRuleKeys.all, "testResultsSummary", ruleId] as const,
};

export const auditRules = {
  getAuditRules: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.getAuditRules,
    queryKeyFn: auditRuleKeys.list,
  }),
  getAuditRule: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.getAuditRule,
    queryKeyFn: auditRuleKeys.detail,
  }),
  createAuditRule: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.createAuditRule,
    mutationKey: ["auditRules", "createAuditRule"],
  }),
  updateAuditRule: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.updateAuditRule,
    mutationKey: ["auditRules", "updateAuditRule"],
  }),
  publishAuditRule: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.publishAuditRule,
    mutationKey: ["auditRules", "publishAuditRule"],
  }),
  unpublishAuditRule: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.unpublishAuditRule,
    mutationKey: ["auditRules", "unpublishAuditRule"],
  }),
  deleteAuditRule: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.deleteAuditRule,
    mutationKey: ["auditRules", "deleteAuditRule"],
  }),
  startRuleTestRun: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.startRuleTestRun,
    mutationKey: ["auditRules", "startRuleTestRun"],
  }),
  runTestRules: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auditRules.runTestRules,
    queryKeyFn: auditRuleKeys.testResult,
  }),
  testAuditRuleCsv: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.testAuditRuleCsv,
    queryKeyFn: auditRuleKeys.testResultsCsv,
  }),
  runTestRulesSummary: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.runTestRulesSummary,
    queryKeyFn: auditRuleKeys.testResultsSummary,
  }),
  validateRuleCode: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.auditRules.validateRuleCode,
    mutationKey: ["auditRules", "validateRuleCode"],
  }),
};
